// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getEstadisticas as listEstadisticasAPI,
    addEstadistica as addEstadisticaAPI
} from '../../helpers/';

import { estadisticasApiResponseError, estadisticasApiResponseSuccess } from './actions';
import { EstadisticasActionTypes } from './constants';


function* addEstadistica({payload:estadistica}){
    try{
        const response = yield call(addEstadisticaAPI,{...estadistica})
        const estadisticaItem = response.data.data
        yield put(estadisticasApiResponseSuccess(EstadisticasActionTypes.ADD_ESTADISTICA,estadisticaItem))
    } catch(error){
        yield put(estadisticasApiResponseError(EstadisticasActionTypes.ADD_ESTADISTICA,error))
    }
}

function* listEstadisticas({payload:params}) {
    try {
        const response = yield call(listEstadisticasAPI, { ...params });
        const listaEstadisticas = response.data.data;
        yield put(estadisticasApiResponseSuccess(EstadisticasActionTypes.LIST_ESTADISTICAS, listaEstadisticas));
    } catch (error) {
        yield put(estadisticasApiResponseError(EstadisticasActionTypes.LIST_ESTADISTICAS, error));
    }
}

export function* watchListEstadisticas(): any {
    yield takeEvery(EstadisticasActionTypes.LIST_ESTADISTICAS, listEstadisticas);
}

export function* watchAddEstadistica():any{
    yield takeEvery(EstadisticasActionTypes.ADD_ESTADISTICA,addEstadistica)
}

function* estadisticasSaga(): any {
    yield all([
        fork(watchListEstadisticas),
        fork(watchAddEstadistica),
    ]);
}

export default estadisticasSaga;